import { render } from "./IconLineUp.vue?vue&type=template&id=8b71da7e&ts=true"
import script from "./IconLineUp.vue?vue&type=script&lang=ts"
export * from "./IconLineUp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__